import { render, staticRenderFns } from "./basiCinformation.vue?vue&type=template&id=7cd8193e"
import script from "./basiCinformation.vue?vue&type=script&lang=js"
export * from "./basiCinformation.vue?vue&type=script&lang=js"
import style0 from "./basiCinformation.vue?vue&type=style&index=0&id=7cd8193e&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod-gz-clzjn-management-platform-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cd8193e')) {
      api.createRecord('7cd8193e', component.options)
    } else {
      api.reload('7cd8193e', component.options)
    }
    module.hot.accept("./basiCinformation.vue?vue&type=template&id=7cd8193e", function () {
      api.rerender('7cd8193e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/module/marketplane/components/basiCinformation.vue"
export default component.exports